import React, { useState } from "react";

interface Props {
  label: string;
  value: unknown;
}

/** Pretty-printed JSON with a copy button - used in the developer drawer. */
const JsonBlock: React.FC<Props> = ({ label, value }) => {
  const [copied, setCopied] = useState(false);
  const json = JSON.stringify(value, null, 2);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(json);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* clipboard unavailable - ignore */
    }
  };

  return (
    <div className="rw-json-block">
      <div className="rw-json-header">
        <span className="rw-review-label">{label}</span>
        <button type="button" className="rw-copy-btn" onClick={copy}>
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
      <pre className="rw-json">{json}</pre>
    </div>
  );
};

export default JsonBlock;
